import axios from 'axios';

import type {
	CountryOption,
	CountryWithCultures,
	Currency,
	CurrencyOption,
	LanguageOption,
	TimeZoneOption,
} from './models';
import { countryWithCulturesSchema, currencySchema } from './models';

/**
 * @see Manzanita.Web.Features.Currencies.CurrencyController
 * @see Manzanita.Web.ApiControllers.GlobalizationController
 */

const UnexpectedErrorMessage = 'An unexpected error occurred while calling the globalization API';

export async function getTimeZoneOptions(): Promise<TimeZoneOption[]> {
	try {
		const response = await axios.get<TimeZoneOption[]>('/api/globalization/time-zones');
		return response.data;
	} catch {
		throw new Error(UnexpectedErrorMessage);
	}
}

export async function getCountryOptions(): Promise<CountryOption[]> {
	try {
		const response = await axios.get<CountryOption[]>('/api/globalization/countries');
		return response.data;
	} catch {
		throw new Error(UnexpectedErrorMessage);
	}
}

export async function getCountriesWithCultures(
	checkForPlantEnabled = false,
): Promise<CountryWithCultures[]> {
	const data = (await axios.get<unknown>('/api/countries', { params: { checkForPlantEnabled } }))
		.data;
	return countryWithCulturesSchema.array().parse(data);
}

export async function getSupportedCurrencyOptions(): Promise<CurrencyOption[]> {
	try {
		const response = await axios.get<CurrencyOption[]>('/api/globalization/currencies');
		return response.data;
	} catch {
		throw new Error(UnexpectedErrorMessage);
	}
}

export async function getSupportedCurrencies(): Promise<Currency[]> {
	try {
		const response = await axios.get<unknown>('/api/currencies');
		return currencySchema.array().parse(response.data);
	} catch {
		throw new Error(UnexpectedErrorMessage);
	}
}

export async function getLanguageOptions(): Promise<LanguageOption[]> {
	try {
		const response = await axios.get<LanguageOption[]>('/api/globalization/languages');
		return response.data;
	} catch {
		throw new Error(UnexpectedErrorMessage);
	}
}

export async function getAllSupportedLanguageOptions(): Promise<LanguageOption[]> {
	try {
		const response = await axios.get<LanguageOption[]>(
			'/api/globalization/all-supported-languages',
		);
		return response.data;
	} catch {
		throw new Error(UnexpectedErrorMessage);
	}
}
